var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "mb-0" },
            [
              _vm._v(" " + _vm._s(_vm.$t("platform-usage.title")) + " "),
              _c("v-spacer")
            ],
            1
          ),
          _c("v-progress-linear", {
            attrs: {
              "aria-label": _vm.$t("platform-usage.loading"),
              active: _vm.busy,
              indeterminate: ""
            }
          }),
          _c(
            "div",
            { attrs: { id: "platform-usage-content" } },
            [
              _c(
                "v-card-text",
                { staticClass: "mt-5", attrs: { id: "total-sessions" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("platform-usage.sessions-started", [
                          _vm.usage.totalSessions
                        ])
                      ) +
                      " "
                  )
                ]
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { id: "platform-usage-column-chart" } },
                    [
                      _vm.usage.loaded
                        ? _c("google-chart", {
                            attrs: {
                              type: "ColumnChart",
                              data: _vm.usage.sessions.chartData,
                              options: _vm.usage.sessions.chartOptions
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.usage.loaded && _vm.allModules.length > 0
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("platform-usage.all-modules")
                                    ) +
                                    " "
                                )
                              ]),
                              _c(
                                "v-card-text",
                                [
                                  _c("v-simple-table", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function() {
                                            return [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "platform-usage.module-name"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "platform-usage.session-count"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ]),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.paginatedModules,
                                                  function(module) {
                                                    return _c(
                                                      "tr",
                                                      { key: module.name },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(module.name)
                                                          )
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              module.sessions
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      3150288808
                                    )
                                  }),
                                  _vm.totalPages > 1
                                    ? _c("v-pagination", {
                                        staticClass: "mt-4",
                                        attrs: {
                                          length: _vm.totalPages,
                                          "total-visible": 7
                                        },
                                        model: {
                                          value: _vm.currentPage,
                                          callback: function($$v) {
                                            _vm.currentPage = $$v
                                          },
                                          expression: "currentPage"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.usage.sessions
                ? _c(
                    "v-row",
                    { staticClass: "d-lg-none", attrs: { justify: "center" } },
                    [
                      _c("v-col", [
                        _c(
                          "tbody",
                          _vm._l(_vm.mobileLegendsOfPlatformUsage, function(
                            legend,
                            index
                          ) {
                            return _c("tr", { key: index }, [
                              _c(
                                "td",
                                { staticStyle: { "padding-left": "15px" } },
                                [
                                  _c("v-list-item-avatar", {
                                    staticClass: "align-self-center",
                                    attrs: {
                                      tile: "",
                                      size: "10",
                                      color:
                                        _vm.usage.sessions.chartOptions.colors[
                                          index
                                        ]
                                    }
                                  }),
                                  _vm._v(_vm._s(legend) + " ")
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { attrs: { id: "device-usage" } },
                [
                  _c(
                    "v-col",
                    [
                      _vm.usage.loaded
                        ? _c("google-chart", {
                            attrs: {
                              type: "PieChart",
                              data: _vm.usage.devices.chartData,
                              options: _vm.usage.devices.chartOptions
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.usage.devices
                    ? _c(
                        "v-col",
                        {
                          staticClass: "d-none d-lg-block",
                          staticStyle: { "padding-top": "53px" }
                        },
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.legendsOfDeviceUsage, function(
                              legend,
                              index
                            ) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "padding-right": "10px",
                                      "padding-left": "10px"
                                    }
                                  },
                                  [
                                    _c("v-list-item-avatar", {
                                      attrs: {
                                        tile: "",
                                        size: "10",
                                        color:
                                          _vm.usage.devices.chartOptions.colors[
                                            index
                                          ]
                                      }
                                    }),
                                    _vm._v(_vm._s(legend) + " ")
                                  ],
                                  1
                                )
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.usage.devices
                ? _c(
                    "v-row",
                    { staticClass: "d-lg-none", attrs: { justify: "center" } },
                    [
                      _c("v-col", [
                        _c(
                          "tbody",
                          _vm._l(_vm.legendsOfDeviceUsage, function(
                            legend,
                            index
                          ) {
                            return _c("tr", { key: index }, [
                              _c(
                                "td",
                                { staticStyle: { "padding-left": "15px" } },
                                [
                                  _c("v-list-item-avatar", {
                                    staticClass: "align-self-center",
                                    attrs: {
                                      tile: "",
                                      size: "10",
                                      color:
                                        _vm.usage.sessions.chartOptions.colors[
                                          index
                                        ]
                                    }
                                  }),
                                  _vm._v(_vm._s(legend) + " ")
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }